export var ParseTree;
(function (ParseTree) {
    function make(source, nodes) {
        return { source, nodes };
    }
    ParseTree.make = make;
    function root(tree) {
        return tree.nodes[0];
    }
    ParseTree.root = root;
    function flatten(rootNode) {
        const flattener = (reduced, node) => [
            ...reduced,
            node,
        ];
        const initial = [];
        return visit(initial, flattener, rootNode);
    }
    ParseTree.flatten = flatten;
    function visit(initial, visitor, node) {
        let nextValue = initial;
        switch (node.type) {
            case "CallExpression": {
                for (const arg of node.arguments) {
                    const argVisit = visit(nextValue, visitor, arg);
                    if (argVisit instanceof Error) {
                        return argVisit;
                    }
                    else {
                        nextValue = argVisit;
                    }
                }
                break;
            }
            case "CaseExpression": {
                const valueVisit = visit(nextValue, visitor, node.value);
                if (valueVisit instanceof Error) {
                    return valueVisit;
                }
                else {
                    nextValue = valueVisit;
                }
                for (const caseNode of node.cases) {
                    const caseVisit = visit(nextValue, visitor, caseNode);
                    if (caseVisit instanceof Error) {
                        return caseVisit;
                    }
                    else {
                        nextValue = caseVisit;
                    }
                }
                if (node.else != null) {
                    const elseVisit = visit(nextValue, visitor, node.else);
                    if (elseVisit instanceof Error) {
                        return elseVisit;
                    }
                    else {
                        nextValue = elseVisit;
                    }
                }
                break;
            }
            case "CaseWhen": {
                const valueVisit = visit(nextValue, visitor, node.value);
                if (valueVisit instanceof Error) {
                    return valueVisit;
                }
                else {
                    nextValue = valueVisit;
                }
                const resultVisit = visit(nextValue, visitor, node.result);
                if (resultVisit instanceof Error) {
                    return resultVisit;
                }
                else {
                    nextValue = resultVisit;
                }
                break;
            }
            case "CaseElse": {
                const resultVisit = visit(nextValue, visitor, node.result);
                if (resultVisit instanceof Error) {
                    return resultVisit;
                }
                else {
                    nextValue = resultVisit;
                }
                break;
            }
            case "IfExpression": {
                const baseVisit = visit(nextValue, visitor, node.base);
                if (baseVisit instanceof Error) {
                    return baseVisit;
                }
                else {
                    nextValue = baseVisit;
                }
                for (const elseNode of node.elses) {
                    const elseVisit = visit(nextValue, visitor, elseNode);
                    if (elseVisit instanceof Error) {
                        return elseVisit;
                    }
                    else {
                        nextValue = elseVisit;
                    }
                }
                if (node.else != null) {
                    const elseVisit = visit(nextValue, visitor, node.else);
                    if (elseVisit instanceof Error) {
                        return elseVisit;
                    }
                    else {
                        nextValue = elseVisit;
                    }
                }
                break;
            }
            case "IfBase": {
                const condVisit = visit(nextValue, visitor, node.condition);
                if (condVisit instanceof Error) {
                    return condVisit;
                }
                else {
                    nextValue = condVisit;
                }
                const resultVisit = visit(nextValue, visitor, node.result);
                if (resultVisit instanceof Error) {
                    return resultVisit;
                }
                else {
                    nextValue = resultVisit;
                }
                break;
            }
            case "ElseIf": {
                const condVisit = visit(nextValue, visitor, node.condition);
                if (condVisit instanceof Error) {
                    return condVisit;
                }
                else {
                    nextValue = condVisit;
                }
                const resultVisit = visit(nextValue, visitor, node.result);
                if (resultVisit instanceof Error) {
                    return resultVisit;
                }
                else {
                    nextValue = resultVisit;
                }
                break;
            }
            case "IfElse": {
                const resultVisit = visit(nextValue, visitor, node.result);
                if (resultVisit instanceof Error) {
                    return resultVisit;
                }
                else {
                    nextValue = resultVisit;
                }
                break;
            }
            case "UnaryExpression": {
                const operandVisit = visit(nextValue, visitor, node.operand);
                if (operandVisit instanceof Error) {
                    return operandVisit;
                }
                else {
                    nextValue = operandVisit;
                }
                break;
            }
            case "BinaryExpression":
            case "LogicalExpression": {
                const leftVisit = visit(nextValue, visitor, node.left);
                if (leftVisit instanceof Error) {
                    return leftVisit;
                }
                else {
                    nextValue = leftVisit;
                }
                const rightVisit = visit(nextValue, visitor, node.right);
                if (rightVisit instanceof Error) {
                    return rightVisit;
                }
                else {
                    nextValue = rightVisit;
                }
                break;
            }
        }
        return visitor(nextValue, node);
    }
    ParseTree.visit = visit;
    function pipeline(visitors) {
        return (initial, node) => {
            let nextValue = initial;
            for (const visitor of visitors) {
                const nodeVisit = visitor(nextValue, node);
                if (nodeVisit instanceof Error) {
                    return nodeVisit;
                }
                else {
                    nextValue = nodeVisit;
                }
            }
            return nextValue;
        };
    }
    ParseTree.pipeline = pipeline;
    let Pipeline;
    (function (Pipeline) {
        function visit(initial, tree, visitor) {
            let nextValue = initial;
            for (const node of tree.nodes) {
                const nodeVisit = ParseTree.visit(nextValue, visitor, node);
                if (nodeVisit instanceof Error) {
                    return nodeVisit;
                }
                else {
                    nextValue = nodeVisit;
                }
            }
            return nextValue;
        }
        Pipeline.visit = visit;
    })(Pipeline = ParseTree.Pipeline || (ParseTree.Pipeline = {}));
})(ParseTree || (ParseTree = {}));
